export const productData = {
  name: "XDigitalApps",
  tagline: "Digital Apps. Smarter with AI.",
  description: "XDigitalApps is a modern digital platform that unifies contact management, event planning, and AI-powered automation into a single, intelligent experience."
};

export const apps = [
  {
    id: 1,
    title: "Smart Contact Cards",
    icon: "👤",
    gradient: "from-blue-500 to-cyan-500",
    description: "Store more than names and numbers. Create rich digital contact profiles that capture roles, relationships, and interaction history.",
    features: ["Context-aware profiles", "Relationship mapping", "Interaction history", "Advanced search"],
    extra: "Perfect for networking, client management, and long-term relationship tracking."
  },
  {
    id: 2,
    title: "Event Manager",
    icon: "📅",
    gradient: "from-purple-500 to-pink-500",
    description: "From small meetups to large gatherings, plan schedules, track participants, send reminders, and gain insights.",
    features: ["Schedule planning", "Participant tracking", "Automated reminders", "Post-event analytics"],
    extra: "Ideal for meetups, workshops, conferences, and internal team events."
  },
  {
    id: 3,
    title: "AI Assistant",
    icon: "🤖",
    gradient: "from-emerald-500 to-teal-500",
    description: "Connects data across contacts and events to surface insights, suggest follow-ups, and reduce repetitive manual work.",
    features: ["Smart recommendations", "Automated follow-ups", "Predictive insights", "Workflow automation"],
    extra: "Reduces manual work by surfacing what matters at the right time."
  }
];

export const useCases = [
  {
    id: 1,
    title: "Individuals",
    icon: "👤",
    description: "Organize personal and professional contacts and maintain context about people you meet.",
    bgColor: "bg-gradient-to-br from-blue-50 to-cyan-50",
    iconColor: "text-blue-600"
  },
  {
    id: 2,
    title: "Professionals",
    icon: "💼",
    description: "Manage client relationships, meetings, and follow-ups with AI-assisted insights.",
    bgColor: "bg-gradient-to-br from-purple-50 to-pink-50",
    iconColor: "text-purple-600"
  },
  {
    id: 3,
    title: "Event Organizers",
    icon: "🎯",
    description: "Plan meetups, workshops, and conferences while tracking participants and engagement.",
    bgColor: "bg-gradient-to-br from-emerald-50 to-teal-50",
    iconColor: "text-emerald-600"
  },
  {
    id: 4,
    title: "Teams & Communities",
    icon: "👥",
    description: "Maintain shared directories, coordinate events, and collaborate without complex tools.",
    bgColor: "bg-gradient-to-br from-amber-50 to-orange-50",
    iconColor: "text-amber-600"
  }
];

export const howItWorks = [
  {
    step: "01",
    title: "Create & Capture",
    description: "Add contacts, events, and notes using simple, intuitive inputs.",
    icon: "📝",
    color: "border-blue-500"
  },
  {
    step: "02",
    title: "Organize & Connect",
    description: "Information is automatically structured and linked across contacts and events.",
    icon: "🔗",
    color: "border-purple-500"
  },
  {
    step: "03",
    title: "Enhance with AI",
    description: "AI surfaces insights, enables fast search, and recommends next actions.",
    icon: "✨",
    color: "border-emerald-500"
  },
  {
    step: "04",
    title: "Act & Automate",
    description: "Follow up and manage relationships with reduced manual effort.",
    icon: "⚡",
    color: "border-amber-500"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Chen",
    role: "Product Director, TechCorp",
    content: "XDigitalApps transformed how our sales team manages relationships. The AI insights are game-changing.",
    avatar: "👩‍💼"
  },
  {
    id: 2,
    name: "Marcus Rodriguez",
    role: "Community Lead",
    content: "Planning events has never been easier. The integration between contacts and events saves us hours weekly.",
    avatar: "👨‍💼"
  }
];

export const features = [
  "AI-powered insights and recommendations",
  "Seamless contact-event integration",
  "Enterprise-grade security",
  "Real-time collaboration",
  "Customizable workflows",
  "Scalable from solo to team use"
];